import React, { useState } from "react"
import { Button, Spinner } from "react-bootstrap"
import { useNavigate } from "react-router-dom";
import { usePermissions } from "../../../hooks/usePermissions";

export const SubmitButton = ({ editMode, entity, entityLoading, field, isAdmin, writeAccess, handleSubmit, onSubmit, watch, confirm, modalContext }) => {
  const redirect = useNavigate();
  const [localWrite] = usePermissions(field.permissions);
  const [isAwaiting, setIsAwaiting] = useState(false);
  return (
    <Button
      type="submit"
      disabled={isAwaiting || !localWrite || (editMode && !entity) || entityLoading || (field.adminOnly && !isAdmin) || !writeAccess || (field.disabled ? field.disabled({ watch }, entity) : false)}
      onClick={async () => {
        setIsAwaiting(true);
        try {
          await handleSubmit(onSubmit)();
          if (field.onAfterSubmit) {
            field.onAfterSubmit({ redirect, confirm, modalContext, watch });
          }
        } finally {
          setIsAwaiting(false);
        }
      }}
      style={field?.style ? field.style : { marginLeft: 'auto' }}
      //field.onAfterSubmit({redirect, confirm});
    >
      {field.label || 'Update'}
      {isAwaiting && <Spinner animation="border" size="sm" />}
    </Button>
  )
}